import MobileCraqueBagre from '../MobileCraqueBagre';
import { BolaoResultadoHistorico } from './BolaoResultadoHistorico';
import { JogoPlacarHeader } from './JogoPlacarHeader';
import {
  EstatisticasCard,
  IncidentesTimeline,
  EscalacaoCard,
  FunFactsCard,
} from './JogoSharedCards';
import type { FutebolPartidaAtiva, FutebolJogoDia } from '@/shared/types';

interface Props {
  telaId: string;
  partida: FutebolPartidaAtiva;
  jogo: FutebolJogoDia | null;
  exibirBolao: boolean;
}

export function JogoEncerradoView({ telaId, partida, jogo, exibirBolao }: Props) {
  const nomeCasa = jogo?.time_casa      ?? '–';
  const nomeVis  = jogo?.time_visitante ?? '–';

  return (
    <>
      <div className="sticky top-0 z-20 shrink-0 bg-jukebox-bg">
        <JogoPlacarHeader partida={partida} jogo={jogo} modo="encerrado" />
      </div>

      <div className="px-4 pt-4 pb-24 space-y-4 flex-1">
        {partida.incidents && partida.incidents.length > 0 && (
          <IncidentesTimeline
            incidents={partida.incidents}
            nomeCasa={nomeCasa}
            nomeVisitante={nomeVis}
          />
        )}

        {exibirBolao && partida.fixture_id != null && (
          <BolaoResultadoHistorico
            telaId={telaId}
            fixtureId={partida.fixture_id}
            placarCasa={partida.placar_casa}
            placarVisitante={partida.placar_visitante}
          />
        )}

        {partida.stats && (
          <EstatisticasCard stats={partida.stats} nomeCasa={nomeCasa} nomeVisitante={nomeVis} />
        )}

        {partida.fixture_id != null && (
          <MobileCraqueBagre
            telaId={telaId}
            fixtureId={partida.fixture_id}
            ultimoEvento={partida.ultimo_evento ?? null}
          />
        )}

        {partida.lineup && partida.lineup.status !== 'unavailable' && (
          <EscalacaoCard lineup={partida.lineup} nomeCasa={nomeCasa} nomeVisitante={nomeVis} />
        )}
        {partida.funfacts && partida.funfacts.length > 0 && (
          <FunFactsCard funfacts={partida.funfacts} />
        )}
      </div>
    </>
  );
}
